<template>
  <div class="delivery-options-grid">
    <ol
      v-if="hasLoadedOptions"
      class="row-gutter-sm options-grid"
    >
      <li
        v-for="deliveryOption in deliveryOptions"
        :key="deliveryOption.value"
        class="option col-6 col-md-4 col-lg-2"
      >
        <grid-item
          :delivery-option="deliveryOption"
          @date-selected="dateSelected"
        />
      </li>
    </ol>
    <div
      v-else
      class="row"
    >
      <div class="col-12">
        <p>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
          />
          <span>{{ i18n('loadingMessage') }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import GridItem from '@/components/GridItem';

export default {
  name: 'OptionsGrid',
  components: {
    GridItem
  },
  props: {
    deliveryOptions: {
      type: Array,
      required: true
    },
    configuredCount: {
      type: Number,
      required: true
    }
  },
  computed: {
    hasLoadedOptions() {
      return this.configuredCount === 0 || !!this.deliveryOptions.length
    }
  },
  methods: {
    i18n(key, values = null) {
      return this.$t(this.i18nPath(key), values);
    },
    i18nPath(key) {
      return `optionsGrid.${key}`;
    },
    dateSelected(selection) {
      this.$emit('date-selected', selection);
    }
  }
};
</script>

<style lang="scss">
#core-availability {
  .options-grid {
    padding: 0;
    list-style: none;
    margin-bottom: 0.5rem;

    .option {
      display: block;
      margin-bottom: $grid-gutter-width-sm;
    }
  }
}
</style>
